<template>
  <div class="modal fade" tabindex="-1" ref="detailModalRef" aria-labelledby="editUserDomainLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editUserDomainLabel">
            Edit Domain for {{ props.detailUser?.firstname }} {{ props.detailUser?.lastname }}
          </h5>
          <button type="button" class="btn-close" aria-label="Close" @click="props.closeDetailModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="domainSelect" class="form-label">Choose a new domain:</label>
            <select
              id="domainSelect"
              :value="props.detailUser?.domainId"
              @change="onChange"
              class="form-select"
            >
              <option
                v-for="opt in props.domainOptionsWithAll"
                :key="opt.value ?? 'No Domain'"
                :value="opt.value"
              >
                {{ opt.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <el-button type="button" class="btn btn-secondary" :disabled="isSubmitting" @click="props.closeDetailModal">Cancel</el-button>
          <el-button type="button" class="btn btn-primary" :disabled="isSubmitting" @click="handleUpdate">Save</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Modal } from 'bootstrap';
import { onMounted, ref } from 'vue';

const detailModalRef = ref<HTMLDivElement | null>(null)
let modalInstance: Modal | null = null

const props = defineProps<{
  detailUser: any
  domainOptionsWithAll: { value: number | null; label: string }[]
  closeDetailModal: () => void
  isSubmitting: boolean
  onSubmit: (domainId: number | null) => void
}>()

const selectedDomain = ref<number | null>(null)

function onChange(e: Event) {
  const value = (e.target as HTMLSelectElement).value
  selectedDomain.value = value ? +value : null
}

onMounted(() => {
  if (detailModalRef.value) {
    modalInstance = new Modal(detailModalRef.value)
  }
})

const handleUpdate = () =>{
  props.onSubmit(selectedDomain.value ? +selectedDomain.value : null)
}

defineExpose({
  openModal: () => {
    modalInstance?.show()
  },
  closeModal: () => {
    modalInstance?.hide()
  }
})
</script>

<style scoped>
  .modal-title{
    font-size: 16px
  }
  .btn{
    border-radius: 6px !important;
  }
  .btn-primary{
    background: #000; 
  }
  .btn-secondary{
    background: #fff; 
    color: #000;
    border: 1px solid #DDD;
  }
</style>
